// Query type identifiers for batch data fetching in PropertyShow. Produced
// by `BatchQueryError` in `dataBatching.js` and surfaced to the consumer via
// `usePropertyData` so the fallback UI can render a query-specific message.
// eslint-disable-next-line import/prefer-default-export
export const PROPERTY_SHOW_QUERY_TYPES = Object.freeze({
  METERS: 'metersQuery',
  RULES: 'rulesQuery',
  METER_DATA: 'meterDataQuery',
  METER_TRADE_SET_SUMMARY: 'meterTradeSetSummaryQuery',
});
